module.exports = __webpack_public_path__ + "static/media/211CS238.b1288689.jpg";